function redirect(name) {
    return (_, { input }, { getCacheKey }) => {
        let id = '';
        if (input) {   
            if (input.clientId) {
                id += input.clientId;
            }
            if (input.unitId) {
                id += input.unitId;
            }
            if (input.typedId) {
                id += input.typedId;
            }   
        }
        let __typename = name.replace('list', '');
        __typename = name.substring(0, name.length - 1);
        __typename += "Connection";
        let result = getCacheKey({ __typename, id });
        console.info("redirect result");
        console.log(__typename);
        console.info(result);

        return result;
    }
}

const Query = {};
[
    'listClients',
    'listThreads',
    'listComments',
    'listDashboards',
    'listCharts',
    'listTriggerableStats',
    'listUnitGroups',
    'listSensorTypes',
    'listUnits',
    'listUnitEvents',
    'listUnitSensors',
    'listActions',
    'listUnitComms'
].forEach(query => {
    Query[query] = redirect(query);
});

export default {
    url: "https://yaw7fxftvjeuridh2sv2sims2i.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    region: "ap-southeast-2",
    cacheOptions: {
        // cacheRedirects: {
        //     Query
        // },
        dataIdFromObject: object => {
            return object.typedId || null ;
        },
        addTypename: false,
        disableOffline: true
    }
};




// WEBPACK FOOTER //
// ./src/services/app-sync/config.js